import React, { useState } from "react";
import styles from "./artworks.module.css";
import CarouselModal from "../components/carouselModal";

const OPTIONS = {};
const SLIDES = [
    { src: require("../static/art/art7.PNG") },
    { src: require("../static/art/art2.PNG") },
    { src: require("../static/art/art4.PNG") },
    { src: require("../static/art/gp.PNG") },
    { src: require("../static/art/bs.jpg") },
    { src: require("../static/art/art14.JPG") },
    { src: require("../static/art/genshin.PNG") },
    { src: require("../static/art/dst1.png") },
    { src: require("../static/art/art1.PNG") },
    { src: require("../static/art/art8.PNG") },
    { src: require("../static/art/omori.PNG") },
    { src: require("../static/art/jw5.PNG") },
    { src: require("../static/art/s2.PNG") },
    { src: require("../static/art/art12.PNG") },
    { src: require("../static/art/jw4.PNG") },
    { src: require("../static/art/gkds.PNG") },
    { src: require("../static/art/gmnt.PNG") },
    { src: require("../static/art/lc4.PNG") },
    { src: require("../static/art/l2.PNG") },
    { src: require("../static/art/mikupokemon.PNG") },
    { src: require("../static/art/tt.jpg") },
    { src: require("../static/art/art6.PNG") },
    { src: require("../static/art/mj.PNG") },
    { src: require("../static/art/nj.jpg") },
    { src: require("../static/art/lc1.PNG") },
    { src: require("../static/art/e2.PNG") },
    { src: require("../static/art/jw6.PNG") },
    { src: require("../static/art/ghmc.PNG") },
    { src: require("../static/art/jw1.PNG") },
    { src: require("../static/art/s1.PNG") },
    { src: require("../static/art/spyfamily.PNG") },
    { src: require("../static/art/sv1.jpg") },
    { src: require("../static/art/jw3.PNG") },
    { src: require("../static/art/jw2.PNG") },
    { src: require("../static/art/art10.PNG") },
    { src: require("../static/art/e1.png") },
    { src: require("../static/art/art3.PNG") },
    { src: require("../static/art/gtswoa.PNG") },
    { src: require("../static/art/hades.png") },
    { src: require("../static/art/gwmwh.PNG") },
    { src: require("../static/art/iforgor.PNG") },
    { src: require("../static/art/art11.PNG") },
    { src: require("../static/art/s3.PNG") },
    { src: require("../static/art/lc3.PNG") },
    { src: require("../static/art/lc2.PNG") },
    { src: require("../static/art/art9.PNG") },
    { src: require("../static/art/dst2.png") },
    { src: require("../static/art/random.png") }
];

function Artworks() {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(0);

    const handleImageClick = (index) => {
        setSelectedIndex(index);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const splitArray = (array, size) => {
        const result = [];
        for (let i = 0; i < array.length; i += size) {
            result.push(array.slice(i, i + size));
        }
        return result;
    };

    const columns = splitArray(SLIDES, 12);

    return (
        <div className={styles.artworksContainer}>
            {isModalOpen && (
                <CarouselModal
                    slides={SLIDES}
                    options={OPTIONS}
                    initialIndex={selectedIndex}
                    onClose={closeModal}
                />
            )}
            <div className={styles.header}>
                <h1 className={styles.headerLight}>My <span className={styles.headerBold}>Artworks</span></h1>
            </div>
            <div className={styles.artworks}>
                <div className={styles.collage}>
                    {columns.map((column, colIndex) => (
                        <div key={colIndex} className={styles.collageCol}>
                            {column.map((slide, index) => (
                                <div
                                    key={index}
                                    onClick={() => handleImageClick(colIndex * 12 + index)}
                                    className={styles.imageWrapper}
                                >
                                    <img className={styles.artwork} src={slide.src} alt={`Artwork ${colIndex * 12 + index}`} />
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            </div>

        </div>
    );
}

export default Artworks;